import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import {
  useExitPreviewMode,
  useIsOrgAdmin,
  usePreviewProgramNames,
} from 'bundles/unified-common/contexts/org-scoped/OrgScopedImpersonationContext';
import type { PreviewModeChangeFailure } from 'bundles/unified-common/contexts/org-scoped/OrgScopedImpersonationContext';
import OrgScopedAdminImpersonationBanner from 'bundles/unified-home-common/components/org-scoped/OrgScopedAdminImpersonationBanner';
import OrgScopedPreviewModeChangeError from 'bundles/unified-home-common/components/org-scoped/OrgScopedPreviewModeChangeError';

const OrgScopedAdminImpersonationBannerRenderer = () => {
  const isAdmin = useIsOrgAdmin();
  const programNames = usePreviewProgramNames();
  const exitPreviewMode = useExitPreviewMode();
  const [exitPreviewFailure, setExitPreviewFailure] = React.useState<PreviewModeChangeFailure | null>(null);

  if (!isAuthenticatedUser() || !isAdmin) return null;

  const handleExitPreviewMode = async () => {
    setExitPreviewFailure(null);
    setExitPreviewFailure((await exitPreviewMode?.()) ?? null);
  };

  return (
    <React.Fragment>
      <OrgScopedAdminImpersonationBanner programNames={programNames} onExitPreviewMode={handleExitPreviewMode} />
      <PageGridContainer>
        <Grid item xs={12}>
          <OrgScopedPreviewModeChangeError
            action="exit"
            failure={exitPreviewFailure}
            onDismiss={() => setExitPreviewFailure(null)}
          />
        </Grid>
      </PageGridContainer>
    </React.Fragment>
  );
};

export default OrgScopedAdminImpersonationBannerRenderer;
